import {Role} from '../../types';

export const RolesMap: Record<Role, string> = {
  [Role.Owner]: 'Owner',
  [Role.Admin]: 'Admin',
  [Role.Contributor]: 'Contributor',
  [Role.Guest]: 'Guest',
  [Role.Connector]: 'Connector',
};
